export interface StoreCategoryNode {
  id: number;
  parentCategoryId?: number | null;
  title: string;
  name: string;
  slug: string;
  description?: string;
  fileId?: string | number;
  childCategories: StoreCategoryNode[];
  childCategoryCount: number;
}

export function buildCategoryTree(categories: StoreCategoryNode[]): StoreCategoryNode[] {
  const byId = new Map<number, StoreCategoryNode>();
  categories.forEach(function (category) {
    byId.set(category.id, { ...category, childCategories: [], childCategoryCount: 0 });
  });
  const roots: StoreCategoryNode[] = [];
  byId.forEach(function (category) {
    const parent = category.parentCategoryId ? byId.get(category.parentCategoryId) : undefined;
    if (parent && parent.id !== category.id) {
      parent.childCategories.push(category);
      parent.childCategoryCount += 1;
    } else if (!category.parentCategoryId) {
      roots.push(category);
    }
  });
  return roots;
}

export function findCategoryPath(categories: StoreCategoryNode[], slug: string, depth = 0): StoreCategoryNode[] {
  if (depth >= 8) return [];
  for (const category of categories) {
    if (category.slug === slug) return [category];
    const path = findCategoryPath(category.childCategories, slug, depth + 1);
    if (path.length) return [category, ...path];
  }
  return [];
}
